import { styled } from '@mui/system';
import { MenuItem } from '@mui/material';

export const useStyles = {
  select: (borderColor, textColor, width) => ({
    width,
    "& .MuiSelect-select": {
      fontSize: '14px',
      padding: "4px 15px!important",
      color: textColor,
      fontWeight: 600,
      background: 'transparent',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: borderColor,
    },
    '.MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${borderColor}`,
      borderRadius: '20px'
    },
    ".MuiSelect-icon": {
      color: textColor
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: borderColor,
    },
    color: textColor,
  }),

  menuProps: (borderColor) => ({
    '& .MuiPaper-root': {
      marginTop: "4px",
      borderRadius: "20px",
      border: `1px solid ${borderColor}`,
    },
  }),
  startAdornment: (textColor) => ({
    "& .MuiTypography-root": {
      fontSize: "14px",
      fontWeight: 600,
      color: textColor
    }
  })
};

export const StyledMenuItem = styled(MenuItem)(({ theme, isSelected, iconColor }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '2px 20px',
  fontSize: "14px",
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  '& .MuiSvgIcon-root': {
    color: isSelected ? iconColor : theme.palette.primary.main,
  },
  "&.Mui-selected": {
    backgroundColor: '#FFF!important'
  }
}));
